import HighchartsRuntime from '../components/charts/highcharts.config';
import { reflowHighchartsToContainer } from './resolve-highcharts-css-colors.util';

export const JEPTO_HIGHCHARTS_PLOT_CONTAINER_SELECTOR =
	'.jepto-line-chart-container, .jepto-area-chart-container, .jepto-bar-chart-container, .jepto-column-chart-container, .jepto-donut-chart-container, .jepto-scatter-chart-container';

/** Reflow every Highcharts plot found under a GridStack item or other layout root. */
export function reflowHighchartsPlotsInElement(root: ParentNode): void {
	if (typeof document === 'undefined') {
		return;
	}

	root
		.querySelectorAll<HTMLElement>(JEPTO_HIGHCHARTS_PLOT_CONTAINER_SELECTOR)
		.forEach(container => {
			const chart = HighchartsRuntime.charts?.find(
				c => c?.container?.parentElement === container
			);
			reflowHighchartsToContainer(chart, container);
		});
}
